import { c as _c } from "react/compiler-runtime";
import { getDefaultLocale } from '@onefootprint/core';
import { IcoEmail16 } from '@onefootprint/icons';
import type { UserConsent, VaultData, VerifiedPrefillContext } from '@onefootprint/request-types';
import { Button, Form, LinkButton, PageShell } from '@onefootprint/ui';
import type { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConsentFooter } from '@/idv2/components/consent-footer';
type ErrorCallback = (message: string) => void;
export type CollectPhoneProps = {
  onSubmit?: (data: VaultData, onError: ErrorCallback) => void;
  isLoading?: boolean;
  email?: string;
  defaultPhone?: string;
  onChangeEmail?: () => void;
  showLegalFooter?: boolean;
  verifiedPrefillContext?: VerifiedPrefillContext;
  headerIcon?: ReactNode;
};
type CollectPhoneFormData = {
  phone: string;
};
export const CollectPhone = t0 => {
  const $ = _c(55);
  const {
    onSubmit,
    isLoading: t1,
    email,
    defaultPhone,
    onChangeEmail,
    showLegalFooter: t2,
    verifiedPrefillContext,
    headerIcon
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const showLegalFooter = t2 === undefined ? false : t2;
  const {
    t,
    i18n
  } = useTranslation("idv2");
  let t3;
  if ($[0] !== i18n.language) {
    t3 = getDefaultLocale(i18n.language);
    $[0] = i18n.language;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const locale = t3;
  const t4 = defaultPhone ?? "";
  let t5;
  if ($[2] !== t4) {
    t5 = {
      defaultValues: {
        phone: t4
      }
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const methods = useForm(t5);
  let t6;
  if ($[4] !== methods || $[5] !== onSubmit) {
    t6 = async data => {
      const vaultData = {
        "id.phone_number": data.phone
      };
      const onError = message => {
        methods.setError("phone", {
          message
        });
      };
      onSubmit?.(vaultData, onError);
    };
    $[4] = methods;
    $[5] = onSubmit;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const handleSubmit = t6;
  let requiredConsent;
  if ($[7] !== showLegalFooter || $[8] !== verifiedPrefillContext) {
    requiredConsent = [];
    if (showLegalFooter) {
      let t7;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
          kind: "terms_and_conditions"
        };
        $[10] = t7;
      } else {
        t7 = $[10];
      }
      requiredConsent.push(t7);
    }
    if (verifiedPrefillContext?.isEnabled) {
      const t7 = verifiedPrefillContext.collectsSsn ?? false;
      let t8;
      if ($[11] !== t7) {
        t8 = {
          kind: "verified_prefill",
          collectsSsn: t7
        };
        $[11] = t7;
        $[12] = t8;
      } else {
        t8 = $[12];
      }
      requiredConsent.push(t8);
    }
    $[7] = showLegalFooter;
    $[8] = verifiedPrefillContext;
    $[9] = requiredConsent;
  } else {
    requiredConsent = $[9];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp2);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== handleSubmit || $[18] !== methods) {
    t9 = methods.handleSubmit(handleSubmit);
    $[17] = handleSubmit;
    $[18] = methods;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== email || $[21] !== onChangeEmail || $[22] !== t) {
    t10 = email && <div className="flex items-center justify-between w-full bg-secondary rounded-sm px-4 py-3" data-dd-privacy="mask"><div className="flex items-center gap-2 min-w-0"><IcoEmail16 className="shrink-0 text-secondary" color="primary" /><span className="text-body-2 text-primary truncate">{email}</span></div><LinkButton onClick={onChangeEmail} className="shrink-0 ml-2">{t(_temp3)}</LinkButton></div>;
    $[20] = email;
    $[21] = onChangeEmail;
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t(_temp4);
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t(_temp5);
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12) {
    t13 = {
      required: t12
    };
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== locale || $[31] !== t11 || $[32] !== t13) {
    t14 = <div className="w-full"><Form.Tel label={t11} name="phone" data-nid-target="phone-number" locale={locale} rules={t13} /></div>;
    $[30] = locale;
    $[31] = t11;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t(_temp6);
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== isLoading || $[37] !== t15) {
    t16 = <Button type="submit" variant="primary" fullWidth={true} size="large" loading={isLoading}>{t15}</Button>;
    $[36] = isLoading;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t10 || $[40] !== t14 || $[41] !== t16 || $[42] !== t9) {
    t17 = <form onSubmit={t9} className="flex flex-col gap-4 items-start w-full">{t10}{t14}{t16}</form>;
    $[39] = t10;
    $[40] = t14;
    $[41] = t16;
    $[42] = t9;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== methods || $[45] !== t17) {
    t18 = <FormProvider {...methods}>{t17}</FormProvider>;
    $[44] = methods;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== requiredConsent) {
    t19 = <ConsentFooter requiredConsent={requiredConsent} />;
    $[47] = requiredConsent;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== headerIcon || $[50] !== t18 || $[51] !== t19 || $[52] !== t7 || $[53] !== t8) {
    t20 = <PageShell headerIcon={headerIcon} title={t7} subtitle={t8}>{t18}{t19}</PageShell>;
    $[49] = headerIcon;
    $[50] = t18;
    $[51] = t19;
    $[52] = t7;
    $[53] = t8;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
};
export default CollectPhone;
function _temp($) {
  return $.identify.phone.title;
}
function _temp2($_0) {
  return $_0.identify.phone.subtitle;
}
function _temp3($_1) {
  return $_1.identify.phone.change;
}
function _temp4($_2) {
  return $_2.identify.phone.label;
}
function _temp5($_3) {
  return $_3.identify.phone.requiredError;
}
function _temp6($_4) {
  return $_4.identify.phone.continue;
}